export default "__VITE_ASSET__BDyVMiOe__"